import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { ThemeProviderContext } from "../ThemeProvider";
import FocusLock, { MoveFocusInside } from "react-focus-lock";
import useScrollBlocking from "../utils/useScrollBlocking";
import { DialogFooter } from "./DialogFooter";
var dialogWidth;
(function (dialogWidth) {
    dialogWidth["small"] = "w-60";
    dialogWidth["medium"] = "w-80";
    dialogWidth["large"] = "w-96";
    dialogWidth["extra-large"] = "w-128";
})(dialogWidth || (dialogWidth = {}));
export const Dialog = ({ header, children, descriptionId, isOpen, onClose, closeOnClickAway = true, width = "medium", primaryButton, secondaryButton, tertiaryButton, align = "default", buttonLayout = "horizontal", backgroundImage, testId, id = "terra-dialog", }) => {
    const theme = useContext(ThemeProviderContext);
    const isVerticalButtonLayout = buttonLayout === "vertical" || !!tertiaryButton;
    const dialogRef = useRef(null);
    useEffect(() => {
        // close dialog on escape key
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", handleEscape);
        return () => {
            window.removeEventListener("keydown", handleEscape);
        };
    }, [isOpen]);
    useScrollBlocking(isOpen, dialogRef);
    const backdropClickHandler = (e) => {
        if (e.target === e.currentTarget && closeOnClickAway) {
            e.preventDefault();
            onClose();
        }
    };
    const backgroundImageStyle = backgroundImage
        ? {
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
        }
        : {};
    const hasCustomWidth = !Object.keys(dialogWidth).includes(width);
    const hasFooter = primaryButton || secondaryButton || tertiaryButton;
    const headerId = `${id}-header`;
    return isOpen
        ? createPortal(_jsx("div", { className: "fixed top-0 xs:p-3 w-full h-full flex justify-center items-center bg-general-neutral-primary/90", style: { zIndex: theme.menuZIndex }, onClick: backdropClickHandler, id: id, [theme.testAttribute]: testId, children: _jsx("div", { role: "dialog", ref: dialogRef, "aria-labelledby": headerId, "aria-modal": "true", "aria-describedby": descriptionId, style: Object.assign(Object.assign({}, backgroundImageStyle), { width: hasCustomWidth ? width : undefined }), className: classNames("max-w-full xs:rounded-lg overflow-hidden flex h-full xs:h-auto", "bg-background-primary dark:bg-background-primary-darkmode", !hasCustomWidth && dialogWidth[width]), children: _jsx(FocusLock, { returnFocus: true, whiteList: (node) => { var _a; return ((_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.contains(node)) || false; }, children: _jsxs(MoveFocusInside, { className: "flex flex-col h-full h-screen-ios xs:h-auto max-h-screen-ios max-h-screen", children: [_jsx("header", { className: classNames("px-1.5", "py-2", !backgroundImage &&
                                    "border-b border-border-subdued dark:border-border-subdued-darkmode"), children: _jsx("h2", { id: headerId, className: classNames("font-body-large-emphasis text-text-primary dark:text-text-primary-darkmode", {
                                        "text-center": align === "center",
                                    }), children: header }) }), _jsx("section", { className: "overflow-y-auto", children: children }), hasFooter && (_jsx(DialogFooter, { align,
                                primaryButton,
                                secondaryButton,
                                tertiaryButton,
                                isVerticalButtonLayout,
                                showBorder: !backgroundImage }))] }) }) }) }), document.body)
        : null;
};
//# sourceMappingURL=Dialog.js.map